import UnitScale from "../model/enums/UnitScale";

class MeasurementUnitsUtil {
  public static short(value: UnitScale): string {
    if (value === UnitScale.Millimeter) {
      return "mm";
    }

    if (value === UnitScale.Centimeter) {
      return "cm";
    }

    if (value === UnitScale.Meter) {
      return "m";
    }

    return "";
  }

  public static long(value: UnitScale): string {
    if (value === UnitScale.Millimeter) {
      return "millimeter";
    }

    if (value === UnitScale.Centimeter) {
      return "centimeter";
    }

    if (value === UnitScale.Meter) {
      return "meter";
    }

    return "unknown";
  }
}

export default MeasurementUnitsUtil;
